<template>
  <div>
    <h2>Alta de Genética</h2>

    <form @submit.prevent="guardarGenetica">
      <div class="mb-3">
        <label for="nombre" class="form-label">Nombre:</label>
        <input v-model="genetica.nombre" type="text" class="form-control" id="nombre" required>
      </div>

      <div class="mb-3">
        <label for="descripcion" class="form-label">Descripción:</label>
        <textarea v-model="genetica.descripcion" class="form-control" id="descripcion" rows="3"></textarea>
      </div>

      <div class="mb-3">
        <label for="thc" class="form-label">THC (%):</label>
        <input v-model="genetica.thc" type="number" class="form-control" id="thc" required min="0">
      </div>

      <div class="mb-3">
        <label for="cbd" class="form-label">CBD (%):</label>
        <input v-model="genetica.cbd" type="number" class="form-control" id="cbd" required min="0">
      </div>

      <!-- Campo: Tipo Origen -->
      <div class="mb-3">
        <label for="tipo_origen" class="form-label">Tipo Origen:</label>
        <select v-model="genetica.tipo_origen" class="form-select" id="tipo_origen" required>
          <option disabled value="">Seleccione un tipo de origen</option>
          <option v-for="origen in origenes" :key="origen" :value="origen">
            {{ origen }}
          </option>
        </select>
      </div>

      <!-- Campo: Tipo Cannabis -->
      <div class="mb-3">
        <label for="tipo_cannabis" class="form-label">Tipo Cannabis:</label>
        <select v-model="genetica.tipo_cannabis" class="form-select" id="tipo_cannabis" required>
          <option disabled value="">Seleccione un tipo de cannabis</option>
          <option v-for="tipo in tiposCannabis" :key="tipo" :value="tipo">
            {{ tipo }}
          </option>
        </select>
      </div>

      <!-- Campo: Tiempo de Floración -->
      <div class="mb-3">
        <label for="tiempo_floracion" class="form-label">Tiempo de Floración (días):</label>
        <input v-model="genetica.tiempo_floracion" type="number" class="form-control" id="tiempo_floracion" min="0">
      </div>

      <!-- Campo: Rendimiento -->
      <div class="mb-3">
        <label for="rendimiento" class="form-label">Rendimiento (kg o unidad):</label>
        <input v-model="genetica.rendimiento" type="number" class="form-control" id="rendimiento" min="0">
      </div>

      <!-- Campo: Observaciones -->
      <div class="mb-3">
        <label for="observaciones" class="form-label">Observaciones:</label>
        <textarea v-model="genetica.observaciones" class="form-control" id="observaciones" rows="3"></textarea>
      </div>

      <!-- Nuevo Campo: Tipo de Resina -->
      <div class="mb-3">
        <label for="tipo_resina" class="form-label">Tipo de Resina:</label>
        <select v-model="genetica.tipo_resina" class="form-select" id="tipo_resina">
          <option disabled value="">Seleccione un tipo de resina</option>
          <option v-for="resina in tiposResina" :key="resina" :value="resina">
            {{ resina }}
          </option>
        </select>
      </div>

      <!-- Nuevo Campo: Perfil Aromático -->
      <div class="mb-3">
        <label for="perfil_aromatico" class="form-label">Perfil Aromático:</label>
        <select v-model="genetica.perfil_aromatico" class="form-select" id="perfil_aromatico">
          <option disabled value="">Seleccione un perfil aromático</option>
          <option v-for="perfil in perfilesAromaticos" :key="perfil" :value="perfil">
            {{ perfil }}
          </option>
        </select>
      </div>

      <!-- Nuevo Campo: Perfil de Terpenos -->
      <div class="mb-3">
        <label for="perfil_terpenos" class="form-label">Perfil de Terpenos:</label>
        <select v-model="genetica.perfil_terpenos" class="form-select" id="perfil_terpenos">
          <option disabled value="">Seleccione un perfil de terpenos</option>
          <option v-for="perfil in perfilesTerpenos" :key="perfil" :value="perfil">
            {{ perfil }}
          </option>
        </select>
      </div>

      <!-- Campo: Fecha de Registro (solo lectura) -->
      <div class="mb-3">
        <label for="fecha_registro" class="form-label">Fecha de Registro:</label>
        <input v-model="genetica.fecha_registro" type="date" class="form-control" id="fecha_registro" disabled>
      </div>

      <button type="submit" class="btn btn-primary">Guardar</button>
    </form>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
 
  data() {
    return {
      clubActual: this.$store.getters.getClubActual,
      genetica: {
        nombre: '',
        descripcion: '',
        thc: null,
        cbd: null,
        tipo_origen: '',      // "planta_madre", "semilla", etc.
        tipo_cannabis: '',    // "Sativa", "Indica", "Híbrida", etc.
        tiempo_floracion: null,
        rendimiento: null,
        observaciones: '',
        fecha_registro: this.obtenerFechaActual(),
        tipo_resina: '',      // Ej.: "grasosa", "pegajosa", "seca", "cristalina".
        perfil_aromatico: '', // Ej.: "cítrico", "terroso", "pino", "floral".
        perfil_terpenos: '',  // Ej.: "Mirceno", "Limoneno", etc.
      },
      origenes: [],        // Se cargan desde /constantes/origen_genetica_cannabis
      tiposCannabis: [],   // Se cargan desde /constantes/tipos_cannabis
      tiposResina: [],     // Se cargan desde /constantes/tipos_resina
      perfilesAromaticos: [], // Se cargan desde /constantes/perfiles_aromaticos
      perfilesTerpenos: [],   // Se cargan desde /constantes/perfiles_terpenos
    };
  },
  methods: {
    async guardarGenetica() {
      // Validación de números negativos
      if (
        this.genetica.thc < 0 ||
        this.genetica.cbd < 0 ||
        (this.genetica.tiempo_floracion !== null && this.genetica.tiempo_floracion < 0) ||
        (this.genetica.rendimiento !== null && this.genetica.rendimiento < 0)
      ) {
        alert('No se permiten valores negativos en los campos numéricos.');
        return;
      }
      try {
          const response = await axios.post(`/api/insertarGenetica/${this.clubActual.id}`, this.genetica);
      
        if(response.data.error){
          alert(response.data.error);
          return;
        }
        alert('Genética guardada con éxito');
        this.$emit("accionTerminada");
      } catch (error) {
        console.error('Error al guardar la genética:', error);
      }
    },
    async cargarOrigenes() {
      try {
        const response = await axios.get('/api/constantes/origen_genetica_cannabis');
        this.origenes = response.data;
      } catch (error) {
        console.error('Error al cargar los orígenes:', error);
      }
    },
    async cargarTiposCannabis() {
      try {
        const response = await axios.get('/api/constantes/tipos_cannabis');
        this.tiposCannabis = response.data;
      } catch (error) {
        console.error('Error al cargar los tipos de cannabis:', error);
      }
    },
    async cargarTiposResina() {
      try {
        const response = await axios.get('/api/constantes/tipos_resina');
        this.tiposResina = response.data;
      } catch (error) {
        console.error('Error al cargar los tipos de resina:', error);
      }
    },
    async cargarPerfilesAromaticos() {
      try {
        const response = await axios.get('/api/constantes/perfiles_aromaticos');
        this.perfilesAromaticos = response.data;
      } catch (error) {
        console.error('Error al cargar los perfiles aromáticos:', error);
      }
    },
    async cargarPerfilesTerpenos() {
      try {
        const response = await axios.get('/api/constantes/perfiles_terpenos');
        this.perfilesTerpenos = response.data;
      } catch (error) {
        console.error('Error al cargar los perfiles de terpenos:', error);
      }
    },
    obtenerFechaActual() {
      const hoy = new Date();
      return hoy.toISOString().split('T')[0];
    },
  },
  mounted() {
    this.cargarOrigenes();
    this.cargarTiposCannabis();
    this.cargarTiposResina();
    this.cargarPerfilesAromaticos();
    this.cargarPerfilesTerpenos();
  },
};
</script>

<style scoped>
/* Estilos específicos para tu componente */
</style>
